import { Location, locationName } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const TrackingPage = lazy(() => import('@cobliteam/tracking/src/pages/TrackingPage'));
// Both the gate and the Suspense-fallback skeleton live in the tracking module — bundling
// them together in one lazy chunk keeps the skeleton out of the entry (previously imported
// statically here for the fallback) while preserving the crossfade UX.
const TrackingReplayRouteGate = lazy(() => import('@cobliteam/tracking/src/pages/TrackingReplayRouteGate'));
const TrackingHistoryGatePage = lazy(() => import('@cobliteam/tracking/src/pages/TrackingHistoryGatePage'));

const routes = [
  {
    title: locationName[Location.TRACKING],
    path: Location.TRACKING,
    component: TrackingPage,
    needsGoogleMaps: true,
  },
  {
    title: locationName[Location.TRACKING_REPLAY],
    path: Location.TRACKING_REPLAY,
    component: TrackingReplayRouteGate,
    needsGoogleMaps: true,
  },
  {
    title: locationName[Location.TRACKING_HISTORY],
    path: Location.TRACKING_HISTORY,
    component: TrackingHistoryGatePage,
    needsGoogleMaps: true,
  },
];

export default routes;
